import {
  MCLocation,
  MCTransform,
  errorCode,
  WechatPositionType,
  PositionType,
  Source
} from '@mc/mc-geo-service'
import { platform } from '@/defines/environment'
import { Bridge } from '@mc/mc-jsbridge'

const baiduKey = 'LL2j91HlP49DsyB8wRXRhzoEcAijAPfv' // cspell: disable-line

const getLocationFromAppInfo = () => {
  const locationInfo = { lng: 0, lat: 0 }
  try {
    const res = Bridge.call('getAppInfo')
    if (res && Number(res.ret) === 1 && res.data instanceof Object) {
      locationInfo.lng =
        typeof res.data.lng === 'string'
          ? parseFloat(res.data.lng)
          : res.data.lng
      locationInfo.lat =
        typeof res.data.lat === 'string'
          ? parseFloat(res.data.lat)
          : res.data.lat
    }
    return locationInfo
  } catch (error) {
    return locationInfo
  }
}

const source = (() => {
  switch (platform) {
    case 'ios':
    case 'android':
      // return getLocationFromAppInfo() // Bridge.call('getAppInfo')
      return [Source.app] // Bridge.call('getLocation')
    case 'weixin':
      return [Source.wechat]
    default:
      return [Source.geolocation]
  }
})()

const location = new MCLocation({
  geolocationOptions: {
    enableHighAccuracy: false,
    maximumAge: 0,
    timeout: 3000
  },
  source,
  wechatJSSDKOptions: {
    type: WechatPositionType.wgs84
  }
})

const cache = {
  lat: 0,
  lng: 0
}

const setCache = async position => {
  const { type, lat, lng } = position
  if (type === PositionType.wgs84) {
    try {
      const result = await MCTransform.online.wgs2bd(lat, lng, baiduKey)
      cache.lat = result.lat
      cache.lng = result.lng
    } catch (error) {
      cache.lat = lat
      cache.lng = lng
    }
  } else {
    cache.lat = lat
    cache.lng = lng
  }
}

export const getGeoLocation = async () => {
  try {
    let position = { lng: 0, lat: 0 }
    if (platform === 'ios' || platform === 'android') {
      position = getLocationFromAppInfo()
    } else {
      position = await location.getLocation()
    }
    setCache(position)
    return position
  } catch (error) {
    const { errorDetail: detail } = error
    if (detail) {
      const { code } = detail
      switch (code) {
        case errorCode.LocationError.App_AppResponseError:
          // iOS 在用户关闭定位时，会返回两个 undefined，目前两个 undefined 的大多是这种情况，上报无意义。暂时取消所有两个 undefined 情况的上报。
          if (
            platform !== 'ios' ||
            error.errorDetail.errorObject.lat !== undefined ||
            error.errorDetail.errorObject.lng !== undefined
          ) {
            // eslint-disable-line camelcase
            // 定位未开启错误过滤
          }
          break
        case errorCode.LocationError.ProgramError:
          break
        case errorCode.LocationError.Wechat_SDKNotInit:
          // TODO: 微信配置！
          // await wxUtil.ready()
          return getGeoLocation()
      }
    }
  }
}

export const getGeoLocationCached = () => {
  if (cache.lat === 0 && cache.lng === 0) {
    getGeoLocation()
  }
  return cache
}
